import useComputed from '@/hooks/use-computed'
import api from '@/services/api/subscriptions.js'
import titleCase from '@/utils/title-case'
import { immerable } from "immer"
import { orderBy } from 'lodash'
import { useState } from 'react'

class Subscriptions {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.type = params.type
		this.status = params.status
		this.consumer = params.consumer
		this.provider = params.provider
		this.dataElement = params.dataElement
		this.dateRequested = params.dateRequested
		this.requiredFields = params.requiredFields
		this.optionalFields = params.optionalFields
	}
}

const useSubscriptions = (subscriptionsId) => {

	const [items, setItems] = useComputed([])
	const [meta, setMeta] = useState(null)

	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		const { meta } = data

		if (!Array.isArray(data.items)) {
			return setError('Subscription is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Subscriptions(params))
		setMeta(meta)
		return setItems(newItems)
	}

	async function find(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data.items)) {
			return setError('Enrolments is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Subscriptions(params))

		return newItems
	}

	async function fetchParticipants(enrollment, type, useCase) {
		const promises = []

		if(!enrollment) {
			return setError("No enrolment data provided")
		}

		// for (const item of data){
		for (const item in enrollment){
			const parameter = {
				status: "APPROVED",
				type: type,
				// dataElementId: item.dataElement.id,
				dataElementId: enrollment[item][0].dataElement.id,
				useCaseId: useCase,
			}

			const params = parameter ? parameter : "";

			promises.push(api.index({params}).then((response)=> {
				const [error, data] = response;

				if(error){
					return null
				}

				const {items} = data

				function lastDateRequested(){
					if (items.length < 1){
						return "NIL"
					}

					return orderBy(items, ["dateRequested"], ['desc'])[0].dateRequested
				}

				const responseData = {
					dataElement : enrollment[item][0].dataElement, fromParticipants: items.map(item=> item.from), toParticipants: items.map(item=> item.to), lastUpdated: lastDateRequested()
				}

				return responseData
			}))
		}

		const responseData = await Promise.all(promises).then(result => {
			return result
		})

		setItems(responseData)
	}


	function serialize(entry) {
		return {
			id: entry.id,
			type: titleCase(entry.type),
			status: entry.status,
			consumer: entry.consumer,
			provider: entry.provider,
			dataElement: entry.dataElement,
			dateRequested: entry.dateRequested,
			optionalFields: entry.optionalFields,
			requiredFields: entry.requiredFields,
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		meta,
		fetchParticipants
	}

}

export default useSubscriptions;
